/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindAllVersionsQueryResponse, PromptsControllerFindAllVersionsPathParams, PromptsControllerFindAllVersions401, PromptsControllerFindAllVersions403, PromptsControllerFindAllVersions404 } from "../../models/promptsController/PromptsControllerFindAllVersions";

function getPromptsControllerFindAllVersionsUrl(id: PromptsControllerFindAllVersionsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/prompts/${id}/versions` as const }  
  return res
}

/**
 * @summary Get all versions of a prompt
 * {@link /api/v1/prompts/:id/versions}
 */
export async function promptsControllerFindAllVersions(id: PromptsControllerFindAllVersionsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerFindAllVersionsQueryResponse, ResponseErrorConfig<PromptsControllerFindAllVersions401 | PromptsControllerFindAllVersions403 | PromptsControllerFindAllVersions404>, unknown>({ method : "GET", url : getPromptsControllerFindAllVersionsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}